import { render } from "./Fulfilment.vue?vue&type=template&id=47232ca1"
import script from "./Fulfilment.vue?vue&type=script&lang=js"
export * from "./Fulfilment.vue?vue&type=script&lang=js"

import "./Fulfilment.vue?vue&type=style&index=0&id=47232ca1&lang=scss"

import exportComponent from "/home/runner/work/intelli-landing-frontend/intelli-landing-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__